import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as RolesRouteMap from 'src/app/data/constants/roles';
import { USERDOCS } from '../help-doc.data';
import { environment } from '../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-help-documention',
  templateUrl: './help-documention.component.html',
  styleUrls: ['./help-documention.component.scss']
})
export class HelpDocumentionComponent implements OnInit {
  sidenavstate;
  userTypeRole;
  src: string;
  docEnvPath: string;
  PetitionerfileDetails = USERDOCS.PETITIONER;
  AttorneyfileDetails = USERDOCS.ATTORNEY;
  BeneficiaryfileDetails = USERDOCS.BENEFICIARY;
  PetitionerfileMenu = USERDOCS.PETITIONER_MENU;
  AttorneyfileMenu = USERDOCS.ATTORENY_MENU;
  BeneficiaryfileMenu = USERDOCS.BENEFICIARY_MENU;
  fileDetails = [];
  fileMenu = [];

  iframeHieght = [{ id: 'idIframe0', height: '500px' },
  { id: 'idIframe1', height: '500px' },
  { id: 'idIframe2', height: '31000px' },
  { id: 'idIframe3', height: '10000px' },
  { id: 'idIframe4', height: '2500px' }
  ];
  constructor(private router: Router, public sanitizer: DomSanitizer) {
    this.src = '../../../assets/The Petitioner Guide_v5.html';
    this.sidenavstate = 'opened';
  }

  ngOnInit() {
    this.userTypeRole = sessionStorage.getItem('userTypeRole');
    this.docEnvPath = environment.docs;
    this.prepareFileList()

  }

  sidenaveState(state) {
    this.sidenavstate = state;
  }

  backToDashboard() {
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/${sessionStorage.getItem('userTypeRole') === RolesRouteMap.ATTORNEY ? 'attorney' : (sessionStorage.getItem('userTypeRole') === RolesRouteMap.BENEFICIARY) ? 'beneficiary' : 'petitioner'}-dashboard`]);
  }

  prepareFileList() {
    switch (this.userTypeRole) {
      case 'Petitioner': {
        this.fileDetails = this.PetitionerfileDetails;
        this.fileMenu = this.PetitionerfileMenu;
        break;
      }
      case 'Attorney': {
        this.fileDetails = this.AttorneyfileDetails;
        this.fileMenu = this.AttorneyfileMenu;
        break;
      }
      case 'Beneficiary': {
        this.fileDetails = this.BeneficiaryfileDetails;
        this.fileMenu = this.BeneficiaryfileMenu;
        break;
      }
    }
    this.fileDetails.forEach((item, index, array) => { array[index] = this.docEnvPath + array[index] });
  }


  iframeLoaded(id, event: Event) {
    let elmt: HTMLIFrameElement = <HTMLIFrameElement>event.srcElement;
    this.iframeHieght.map((item, idx) => {
      let el1 = <HTMLIFrameElement>event.srcElement;
      item.id == id ? this.setheight(elmt, this.iframeHieght[idx].height) : '';
    });
  }

  setheight(elmt, height) {
    elmt.style.height = height;
    //console.log(height);
  }


}


